import React from 'react'
import { ProjectsPageTemplate } from '../containers/Projects'

export default function ProjectsPage() {
  return (
    <ProjectsPageTemplate
      title="Proyectos"
      intro={
        <>
          Aquí podras ubicar los diferentes proyectos personales y profesionales
          en donde he participado. Disfrutalo!.
        </>
      }
      projects={{
        sotavento: {
          label: 'FAQ Sotavento',
          description: (
            <>
              Página informativa de los futuros residentes del club residencial
              Sotavento.
            </>
          ),
        },
        portafolio: {
          label: 'Mi portafolio personal',
          description: (
            <>
              Este es mi portafolio personal. Desarrollado con las tecnologías
              relevantes para el momento ReactJS y GatsbyJS.
            </>
          ),
        },
      }}
    />
  )
}
